module.exports = __webpack_public_path__ + "img/kanban07.2d253981.png";